jQuery.noConflict();

(function($) {

    $(function($){
        
        var isMobile = false; //initiate as false
        // device detection
        if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
            || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) isMobile = true;


        $(document).find('*[data-fancybox]').fancybox();

        /*function a5_print() {

            console.log(window.location.href);
            var u=location.href; 
            var t="A5 print"; 
            window.open(window.location.href, "sharer", "toolbar=0,scrollbar=yes,status=0,width=530,height=764"); 
            return false;
        }*/

        (function () {
            let sTrigger = $('#search-trigger'),
                sWrapper = $('#search-wrapper'),
                $body = $('body'),
                $form = $('#searchform'),
                $overlay = $('.overlay'),
                $close = sWrapper.find('.close');

            sWrapper.open = false;
            sWrapper.toggler = function(){
                this.toggleClass('active');
                $body.toggleClass('overlay-active').toggleClass('prevent-scroll');
                $form.find(':text').trigger('focus');
                sWrapper.open = !sWrapper.open;
            };
            sWrapper.closer = function() {
                this.removeClass('active');
                $body.removeClass('overlay-active').removeClass('prevent-scroll');
                sWrapper.open = false;
            };

            sTrigger.on('click', function (e) {
               e.preventDefault();
               sWrapper.toggler();
            });

            $close.on('click', function (e) {
                e.preventDefault();
               sWrapper.closer();
            });

            sWrapper.on('click', function (e) {
                e.preventDefault();
                sWrapper.closer();
             });

            $form.on('click', function (e) {
                e.stopPropagation();
            });


        })();



        (function () {
            let $navbar_main = $('#navbar-transform'),
                $searchBox = $navbar_main.find('#search-box');

                $navbar_main.on('focusin', '#search-box', function (e) {
                    var that =  $(e.delegateTarget);
                    that.addClass('search-active');
                });

                $navbar_main.on('focusout', '#search-box', function (e) {
                    var that =  $(e.delegateTarget);  
                    that.removeClass('search-active');
                });

        })();
        (function () {

            if(isMobile == false){
                $('.slick-slider').slick({
                    vertical: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: true,
                    arrows: true,
                    prevArrow: '<div class="slick-prev"></div>',
                    nextArrow: '<div class="slick-next"></div>',
                    dots: true,
                    /*customPaging : function(slider, i) {
                        return '<a href="#"><img src="images/slide-dot.png" /><img src="images/slide-dot-active.png" /></a>';
                    },*/
                });
            }

            

        })();

        (function () {
            let $searchWrapper = $('#search-wrapper'),
                $searchForm = $searchWrapper.find('#searchform'),
                $searchInput = $searchForm.find('#s');

            $searchInput.on('change', function () {
                console.log('changed');
            });
        })();


        (function () {
            let $newsletter = $('#newsletter');
            $newsletter.on('submit', function (e) {
                $(this).find('.required').each(function(i, el){
                   if($(el).val() === '') {
                       return false;
                   }
                });                
            });
        })();
									

        $('.print-trigger').on('click', function (e) {
            
            e.preventDefault();
            if (e.shiftKey) {
                $('body').data('print', 'A5');
                $('body').attr('print', 'A5');
                $('body').addClass('format-A5');
                $('body').removeClass('format-A4');
               
            } else {
                $('body').data('print', 'A4');
                $('body').attr('print', 'A4');
                $('body').addClass('format-A4');
                $('body').removeClass('format-A5');
            }
            
            return window.print();
        });

        window.onbeforeprint = function() {
            console.log('This will be called before the user prints.');
        };
        window.onafterprint = function() {
            console.log('This will be called after the user prints');   
        };


        /*(function(){

            function toggleDropdown (e) {
                
                const _d = $(e.target).closest('.dropdown'),
                  _m = $('.dropdown-menu', _d);
                setTimeout(function(){
                  const shouldOpen = e.type !== 'click' && _d.is(':hover');
                  _m.toggleClass('show', shouldOpen);
                  _d.toggleClass('show', shouldOpen);
                  $('[data-toggle="dropdown"]', _d).attr('aria-expanded', shouldOpen);
                }, e.type === 'mouseleave' ? 300 : 0);
              }
              

                $('body')
                .on('mouseenter mouseleave','.dropdown',toggleDropdown)
                .on('click', '.dropdown-menu a', toggleDropdown);

        })();*/

       


        (function(){

            function toggleDropdown (e) { 
                
                const _d = $(e.target).closest('.dropdown'),
                  _m = $('.dropdown-menu', _d);
                setTimeout(function(){
                  const shouldOpen = e.type !== 'click' && _d.is(':hover');
                  _m.toggleClass('show', shouldOpen);
                  _d.toggleClass('show', shouldOpen);
                  $('[data-toggle="dropdown"]', _d).attr('aria-expanded', shouldOpen);
                }, e.type === 'mouseleave' ? 300 : 0);
              }
              
                $('body')
                .on('mouseenter mouseleave','.dropdown',toggleDropdown)
                .on('click', '.dropdown-menu a', toggleDropdown);

        })();

        

        //console.log($(document).find('.image-content > img')[0].height());

        (function () {

            $('#category-select').on('change', function (e) {
                $(this).trigger('submit');
            });

        })();

        (function () {

            $('.archive-form').on('change', function (e) {
                $(this).trigger('submit');
            });

        })();


        (function () {
            // When the user scrolls the page, execute myFunction
            //window.onscroll = function() { StickyHeader() };
            // Get the navbar
            var navbar = document.getElementById("navbar-transform");
            var subnavbar = document.getElementById("subnavigation");
            var htmlbody = document.body;
            // Get the offset position of the navbar
            var sticky = navbar.offsetTop;
            if(subnavbar != null) {
                var stickysub = subnavbar.offsetTop;
                var stickyTopNavbar = stickysub - subnavbar.offsetHeight;
                //console.log(stickyTopNavbar);
            }

           
            
            // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
            function StickyHeader() {

                if (window.pageYOffset >= sticky) {
                    navbar.classList.add("sticky");
                    htmlbody.classList.add('sticky-on');
                } else {
                    navbar.classList.remove("sticky");
                    htmlbody.classList.remove('sticky-on');
                }

                if(typeof stickysub != 'undefined') {

                    if (window.pageYOffset >= stickysub) {
                        subnavbar.classList.add("sticky");
                    } else {
                        subnavbar.classList.remove("sticky");
                    }

                   /* if (window.pageYOffset >= stickyTopNavbar) {
                        navbar.classList.add("sticky-hide")
                    } else {
                        navbar.classList.remove("sticky-hide");
                    }*/
                }   
            }
        })();
  
        //Initial load - draws map and calls drawMarketsOnMap
        (function() {
            const $map = $('#map');

            if ($map.length > 0) {
                window.pakrings_map = new GMaps({
                    div: '#map',
                    lat: 45.5481,
                    lng: 13.7302,
                    zoom: isMobile ? 13 : 15
                });
                window.infoWindow = new google.maps.InfoWindow(); 
                drawAllMarkers();
            }
            
        })();

        function drawAllMarkers() {

            if(typeof parkings !== 'undefined') {

                for (const p of Object.values(parkings)) {
                    drawMarketsOnMap(p);
                }

            }
        }

        

        function attachPolygonInfoWindow(polygon, coors, html)
        {
            
            google.maps.event.addListener(polygon, 'click', (function (polygon) {
              
                return function(event){
                    
                    window.infoWindow.setContent(html);
                    window.infoWindow.setPosition(event.latLng);
                    window.infoWindow.open(window.pakrings_map, polygon);
                }

            })(polygon));
           
        }

        //Draw markers, register click events, etc.
        function drawMarketsOnMap(loc) {

            if (!loc || loc.length < 1) {
                return false;
            }

            let path_info = JSON.parse(loc.map_data);
            
            let i;
            let polygonCoords = [];
            let path = path_info[0].path;
            let path_type = path_info[0].type;

            $.each(path, function(index, path_object) {
                //let current_object = [path_object.lat, path_object.lng];
                let current_coord = new google.maps.LatLng(path_object.lat, path_object.lng);
                polygonCoords.push(current_coord);

            });

            /* center test */
            var bounds = new google.maps.LatLngBounds();
            for (i = 0; i < polygonCoords.length; i++) {
                bounds.extend(polygonCoords[i]);
            }
            var stringContent = loc.map_html;

            switch(path_type) {

                case 'polygon':
                   var obj = pakrings_map.drawPolygon({
                        paths: polygonCoords, // pre-defined polygon shape
                        strokeColor: "#03AF4B",
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                        fillColor: "#03AF4B",
                        fillOpacity: 0.7
                    });

                    attachPolygonInfoWindow(obj, bounds.getCenter(), stringContent);
                break;
                case 'polyline':

                    pakrings_map.drawPolyline({
                        path: path_polygon, // pre-defined polygon shape
                        strokeColor: '#00a651',
                        strokeOpacity: 1,
                        strokeWeight: 3,
                    });
                break;

                case 'marker':

                    let xmarker = new Array();
                    xmarker.push({
                        lat: loc.lat,
                        lng: loc.lon,
                        title: loc.title,
                        //icon: image,
                        //shape: shape,
                        infoWindow: {
                            content: loc.map_html
                                
                        }
                    });
                    pakrings_map.addMarkers(xmarker);

                break;




            }

       
        }


        if($('.custom-nav').length > 0) {
            $(".owl-carousel").owlCarousel(
                {
                    loop: true,
                    nav: true,
                    center: true,
                    items: 1,
                    dotsContainer: '#carousel-custom-dots',
                    navContainer: $('.custom-nav'),
                    animateOut: 'fadeOut',
                    animateIn: 'fadeIn',
                    navText: ["<img class='arrow-previous' src='/wp-content/themes/emigma/assets/svg/arrow.svg'>", "<img src='/wp-content/themes/emigma/assets/svg/arrow.svg'>"],
                }
            );
        } else if($(".owl-carousel").length > 0) {

            var $OC = $(".owl-carousel");
            var options = $OC.data('wp-options');

            //console.log(options);

            //$OC.owlCarousel(); 

            if( typeof options === 'object') {

                console.log(options);
                /* owl carousel options from HTML */
                var	_autoplay 			= ( 'yes' === options.autoplay ) ? true : false,
					_nav 		        = ( 'yes' === options.nav ) ? true : false,
					_dots 		        = ( 'yes' === options.dots ) ? true : false,
					_speed 				= ( options.speed!==undefined ) ? options.speed : 500,
                    _items 				= ( options.items!==undefined ) ? options.items:1,
                    _margin 			= ( options.margin!==undefined ) ? options.margin:0,
                    _stagepadding 	    = ( options.stagePadding!==undefined ) ? options.stagePadding:0,
					_tablet 			= ( options.tablet!==undefined ) ? options.tablet:1,
					_mobile 			= ( options.mobile!==undefined ) ? options.mobile:1;

                $OC.owlCarousel(
                    {
                        //loop: true,
                        //center: false,
                        items: _items,
                        margin: _margin,
                        stagePadding: _stagepadding,
                        nav: _nav,
                        dots: _dots,
                        autoplay: _autoplay,
                        autoplaySpeed: _speed,
                        responsiveClass: true,
                        animateOut: 'fadeOut',
                        animateIn: 'fadeIn',
                        /*responsive: {
                            0: {
                                items: _mobile,
                            },
                            480: {
                                items: _tablet,
                            },
                            999: {
                                items: _items,
                            }
                        }*/
                    }
                );
            }

        }

        /*$('.owl-dot').on('click', function () {
            $(".owl-carousel").trigger('to.owl.carousel', [$(this).index(), 300]);
        });*/

        $('#emi-notice').on('closed.bs.alert', function () {
           return setCookie('hideNotice', true, 1);
        });


        function setCookie(cname, cvalue, exdays) {
            let d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            let expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

       

        //These will be updated on window.resize
        //If you want an element to have any of its properties
        //calculated dynamically, please push it to this array in object format
        //Structure of object should be:
        /*
        {
            'element': $('#element'),
            'property': 'padding-left',
            'callback': calcFluidPadding
        }
        */
        let dynamicElements = [];

        function updateDynamicElements() {
            for (const element of dynamicElements) {
                element.element.css(element.property, element.callback)
            }
        }

        (function() {
            var $frame = $('.frame');
            if ($frame.length !== 0) {
                new Sly($frame, {
                    horizontal: 1,
                    itemNav: 'forceCentered',
                    activateMiddle: 1,
                    smart: 1,
                    activateOn: 'click',
                    mouseDragging: 1,
                    touchDragging: 1,
                    releaseSwing: 1,
                    startAt: 1,
                    scrollBy: 1,
                    activatePageOn: 'click',
                    speed: 200,
                    moveBy: 600,
                    elasticBounds: 1,
                    dragHandle: 1,
                    dynamicHandle: 1,
                    clickBar: 1,
                    // Navigation buttons
                    forward:  null, // Selector or DOM element for "forward movement" button.
                    backward: null, // Selector or DOM element for "backward movement" button.
                    prev:     $('.btn.prev'), // Selector or DOM element for "previous item" button.
                    next:     $('.btn.next'), // Selector or DOM element for "next item" button.
                    scrollBar: $('.o-scrollbar')
                }).init();
            }
        })();

        (function() {
            $('.owl-dot a').on('click', function(e) {
                if(!$(this).parent().hasClass('active')) {
                    e.preventDefault();
                }
            });
        })();

        $(window).on('resize', function () {
            updateDynamicElements();
        });


        function calcFluidPadding() {
            let $container = $('.container');
             return ($( 'body' ).width() - $container.width()) / 2;
        }

        let mobileMenu = {
            open: false,
            items: {
                hamburger: $('#burger'),
                burgerWrapper: $('#burger-wrapper'),
                navbar: $('.main-menu-wrapper'),
                body: $('body')
            },
            functions: {
                toggle: function () {
                    this.items.hamburger.toggleClass('animate');
                    this.items.navbar.toggleClass('active');
                    this.items.body.toggleClass('prevent-scroll');
                    this.open = !this.open;
                },
                open: function () {
                    this.items.hamburger.addClass('animate');
                    this.items.navbar.addClass('active');
                    this.items.body.addClass('prevent-scroll');
                    this.open = true;
                },
                close: function () {
                    this.items.hamburger.removeClass('animate');
                    this.items.navbar.removeClass('active');
                    this.items.body.removeClass('prevent-scroll');
                    this.open = false;
                }
            }
        };

        mobileMenu.items.burgerWrapper.on('click', function () {
            mobileMenu.functions.toggle.call(mobileMenu);
            $('#ar-language-switcher').toggleClass('show');
        });

        /*
        ******************************************************************************************************
            Calculates the correct window height and width (including scrollbar)
        ******************************************************************************************************
        */
        function viewport() {
            var e = window, a = 'inner';
            if (!('innerWidth' in window )) {
                a = 'client';
                e = document.documentElement || document.body;
            }
            return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
        }

        /*
        ******************************************************************************************************
            Tables
        ******************************************************************************************************
        */

        $('#content').find('table').each(function(i, el){
            $(el).addClass('table');
        });

        (function () {
            let $table  = $('.table');
            if($table.length > 0){
                $table.each(function(i, table) {
                    if($(table).parent().is(':not(.table-responsive)')) {
                        return $(table).wrap('<div class="table-responsive"></div>');
                    }
                });
            }
        })();



        (function() {

            var previousScroll = 0;
            var currentScroll = 0;

            $(window).on("scroll", function(e) {
                //console.log(e);
                var $header_target = $('.navbar-transform-on-scroll').data('target-px-scroll');

                /*if($(window).scrollTop() > $header_target) {
                    $(".navbar-transform-on-scroll").removeClass("navbar-transform");
                } else {
                    //remove the background property so it comes transparent again (defined in css)
                   $(".navbar-transform-on-scroll").addClass("navbar-transform").removeClass('scrolling');
                }*/


                /*if (!isMobile){ 
                    currentScroll = $(this).scrollTop();
                    if (currentScroll > 0 && currentScroll < $(document).height() - $(window).height()) {
                        if (currentScroll >= previousScroll) {
                           return hideNav();
                        } else {
                         return  showNav();
                        }
                        previousScroll = currentScroll;
                    }
                }*/
                
            });


            // Wheel event hook (working perfectly)

            var scrollableElement = document.body; //document.getElementById('scrollableElement');

            if (!isMobile){ 
               // scrollableElement.addEventListener('wheel', checkScrollDirection);
            }
           

            function checkScrollDirection(event) {
                    if (checkScrollDirectionIsUp(event)) {
                        showNav();
                    } else {
                        hideNav();
                    }
            }

            function checkScrollDirectionIsUp(event) {
                if (event.wheelDelta) {
                    return event.wheelDelta > 0;
                }
                return event.deltaY < 0;
            }

            function hideNav() {
                $(".navbar-transform-on-scroll").removeClass("is-visible").addClass("is-hidden");
            }
        
            function showNav() {
                $(".navbar-transform-on-scroll").removeClass("is-hidden").addClass("is-visible").addClass("scrolling");
            }






        })();



        (function () {

               
            let el = $('#search-query-input'),
                cache = [], 
                submitbox = $('#searchform').find('.search-helper');
                
                
            $('#searchform').on('submit', function (e) {
                submitbox.addClass('preloading');
                e.preventDefault();
            });


            function search(query, callback) {
                
                /** Check if query has been already sent */
                // var stored = cache[query];
                // if (stored) {
                //     callback(JSON.parse(stored));
                //     return;
                // }

                /** No => search for it */
                $.ajax({
                    'method': 'post',
                    'url': localize.ajaxurl,
                    'beforeSend': function() {
                        // setting a timeout
                        submitbox.addClass('preloading');
                    },
                    'data': {
                        q: query,
                        action: 'emigma_ajax_search'
                    },
                    'success': function (payload) {

                        //console.log(JSON.parse(payload));
                        // var results = payload.places.concat(payload.clubs).concat(payload.girls);
                        // cache[query] = JSON.stringify(results);
                        callback(JSON.parse(payload));
                    },
                    complete: function(response){
                        submitbox.removeClass('preloading');
                    }
                });
            }

            el.autocomplete({
                autoselect: true, // Select 1st item × search on enter UX
                autoselectOnBlur: false, // On mobile devices = true @todo
                openOnFocus: true,
                // keyboardShortcuts: ['s'],
                minLength: 2,
            }, [
                {
                    source: search,
                    debounce: 1000,
                    displayKey: function(suggestion) {
                        return suggestion.name
                    },
                    templates: {
                        suggestion: function(suggestion) {
                            var query = $('#search-query-input').autocomplete('val');
                            var regExp = new RegExp('(' + query + ')', 'giu');
                            var $return = '<div class="suggestion-item">' +
                                        '<div class="suggestion-cpt">' + '</div>' +
                                        '<div class="suggestion-title">' +
                                            suggestion.name.replace(regExp, '<span class="highlight">$1</span>')
                                        + '</div>';
                                        if(suggestion.sku){
                                            $return += '<div class="suggestion-excerpt">SKU: ' +
                                                suggestion.sku.replace(regExp, '<span class="highlight">$1</span>') 
                                             '</div>';
                                        }
                                    $return += '</div>';
                            //console.log ($return);
                            return $return;
                        },
                        empty: function() {
                            return '<div class="suggestion-item"><span>'+localize.translations.noResults+'<span></div>';
                        }
                    }
                }
            ]).on('autocomplete:selected', function(event, suggestion, dataset, context) {
                window.location.assign(suggestion.link);
            });

    })();


        //Extends jQuery with .animateCss() method (used for the language switcher among other things)
        $.fn.extend({
            animateCss: function (animationName, callback) {
                var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
                this.addClass('animated ' + animationName).one(animationEnd, function() {
                    $(this).removeClass('animated ' + animationName);
                    if (callback) {
                        callback();
                    }
                });
                return this;
            }
        });


        (function(){
            $('*[data-toggle="tooltip"]').tooltip();
        })();

        //language switcher
        (function () {
            /*
            ******************************************************************************************************
              Language switcher controls
            ******************************************************************************************************
            */
            // Reverse function df
            jQuery.fn.reverse = [].reverse;

            let langSwitcher = {
                open: false,
                items: {
                    body: $('body'),
                    langSwitcher: $('#ar-language-switcher'),
                    langControls: $('#ar-language-switcher .lang-controls'),
                    langItemsInnerWrapper: $('#ar-language-switcher .language-switcher-wrapper .lang-switcher-inner')
                },
                
                functions: {
                    toggle: function (e) {
                        e.preventDefault();

                        if (this.open === false) {
                            this.items.langControls.siblings('.language-switcher-wrapper').addClass('active');

                            let n = 1, len =   this.items.langItemsInnerWrapper.children('a').length;
                            this.items.langItemsInnerWrapper.children('a').each((index, element) => {
                                //Set delay increment with each loop and apply css
                                let d = 0.10 * n + 's';
                                $(element).animateCss('fadeInLeft').css('animation-delay', d).addClass('active');
                                n++;

                                if (index === (len - 1)) {
                                    this.open = !this.open;
                                }

                            });
                        }  else {
                            this.functions.close.call(this);
                        }

                    },

                    close: function () {
                        let n = 1;
                        this.items.langItemsInnerWrapper.children('a').reverse().each(function () { // get all lang items and reverse the array, then do a foreach
                            let d = 0.10 * n + 's';
                            $(this).css('animation-delay', d).animateCss('fadeOutLeft');
                            n++;
                        });
                        this.items.langControls.siblings('.language-switcher-wrapper').removeClass('active');
                        this.items.langItemsInnerWrapper.children('a').removeClass('active');

                        this.open = false;
                    }
                }
            };


            langSwitcher.items.langControls.on('click', function (e) {
                langSwitcher.functions.toggle.call(langSwitcher, e);
            });

            langSwitcher.items.body.on('click', function (e) {
                if (langSwitcher.open === true && !langSwitcher.items.langSwitcher.find('*').is(e.target)) {
                    langSwitcher.functions.close.call(langSwitcher, e);
                }
            });

            $(document).on('click', '[data-toggle="lightbox"]', function(event) {
                event.preventDefault();
                $(this).ekkoLightbox({
                    'alwaysShowClose': true,
                    'scale_height':true
                });
            });

            $(".open-lightbox").on('click', function(e) {
                e.preventDefault();
                $(".second-gallery a").first().trigger('click');
            });

            $(".form-select").on('change', function() {
                var selectedID = $(this).find(":selected").val();
                $(".forms .form").css("display", "none");
               $(".forms .form-" + selectedID).css("display", "block");
            });


            $(".overlay").on('click', function() {
                $(this).removeClass('active');
            });


        })();

    });

})( jQuery );
